import type { SingleAggregateIdentityInterface, SingleAggregateModelInterface } from '@nts/std/interfaces';
import { BaseRootModel } from '../base-root-model';
import { NumberDecorator } from '../decorators/number.decorator';
import { OCCModel } from '../occ-model';
import { Expose } from "@nts/std/serialization";


export class SingleAggregateModel<TSingleAggregateIdentity extends SingleAggregateIdentityInterface>
  extends OCCModel<TSingleAggregateIdentity> implements SingleAggregateModelInterface<TSingleAggregateIdentity> {

  static override PROPERTY_LIST: string[] = [
    ...BaseRootModel.PROPERTY_LIST,
    'fixedIdentity'
  ];

  private _fixedIdentity: number;

  @Expose()
  @NumberDecorator({ displayNameKey: 'SingleAggregateModel_FixedIdentity' })
  get fixedIdentity(): number {
    return this.getValueForIdentityValue<number>(() => this._fixedIdentity, 'fixedIdentity');
  }
  set fixedIdentity(value: number) {
    this.setValueForIdentityValue<number>(() => { this._fixedIdentity = value; }, value, 'fixedIdentity');
  }

}
